import template from './template.html'
import controller from './workflowBar.controller'

export default {
  restrict: 'E',
  template,
  bindings: {
    webskedObj: '<',
    storyObj: '<',
    lockObj: '<',
  },
  controller,
  controllerAs: 'vm',
}
